import { Component, OnInit, DoCheck } from '@angular/core';

import { BaseService } from '../../base.service';
import { ConfigService } from '../../config.service';


@Component({
  selector: 'app-change-order',
  templateUrl: './change-order.component.html',
  styleUrls: ['./change-order.component.css']
})
export class ChangeOrderComponent implements OnInit, DoCheck {
  billdata: any = {};
  billingdata: any = [];

  ProductItems: any[] = [];
  ItemCodesList: any[] = [];

  prouctObject: any = {
    po_no: '',
    item_code: '',
    item_desc: '',
    hsn_code: '',
    qty: '',
    unit_price: 0,
    total: 0
  };

  today: any = new Date();
  totalObject: any = {
    newSubtotal: 0,
    GST: 18,
    SGST: 0,
    CGST: 0,
    GrandTotal: 0
  };

  from_Address: any = "";
  to_Address: any = "";
  invoiceDate: any = new Date();

  invoice_type: any = "Invoice";


  bsValue = new Date();
  selectedPO_no: any;

  constructor(public _baseService: BaseService, public _config: ConfigService) {


    this.addMaterials();

  }

  ngOnInit() {
    this._baseService.getAllProducts();
    this._baseService.getCustomers();
    this._baseService.getAllBanks();
    this._baseService.getLastOrderID();


    setTimeout(() => {

      debugger;

      this.invoice_type = this._baseService.InvoiceData.invoice_type;
      this.from_Address = this._baseService.InvoiceData.from_Address.id;
      this.to_Address = this._baseService.InvoiceData.to_Address.id;
      this._baseService.LastInvoiceID = this._baseService.InvoiceData.invoice_no;
      this.invoiceDate = new Date(this._baseService.InvoiceData.invoiceDate);

      this.ProductItems = this._baseService.InvoiceData.ProductItems;
      this.totalObject = this._baseService.InvoiceData.totalObject;


    }, 300);

  }

  ngDoCheck() {
    this.calculateTotal();
    // this.calculateSubTotal();
    // this.calculateFinalTotal();
  }

  addMaterials() {
    this.ProductItems.push(this.prouctObject);

    this.prouctObject = {
      po_no: '',
      item_code: '',
      item_desc: '',
      hsn_code: '',
      qty: '',
      unit_price: 0,
      total: 0
    };

    this.ItemCodesList = [];

  }

  removeMaterialItem(index: any) {
    this.ProductItems.splice(index, 1);
  }


  calculateTotal() {
    // console.table(this.ProductItems);

    this.ProductItems.forEach(element => {
      element.total = (Number(element.unit_price) * Number(element.qty)).toFixed(2);
    });

    this.calculateSubTotal();
  }


  calculateSubTotal() {

    let subtotalVal = 0;

    this.ProductItems.forEach(element => {
      subtotalVal += Number(element.total);
    });

    this.totalObject.newSubtotal = subtotalVal.toFixed(2);


    this.calculateGrandTotal();
  }


  calculateGrandTotal() {
    // console.table(this.ProductItems);

    let grandTotal = 0;

    let GST_Val = Number((this.totalObject.newSubtotal * this.totalObject.GST) / 100);

    grandTotal = Number(this.totalObject.newSubtotal) + GST_Val;

    this.totalObject.GrandTotal = Number(grandTotal).toFixed(2);


    if (this.totalObject.GST > 0) {
      this.totalObject.CGST = this.totalObject.GST / 2;
      this.totalObject.SGST = this.totalObject.GST / 2;

      this.totalObject.CGST_Val = Number(GST_Val / 2).toFixed(2);
      this.totalObject.SGST_Val = Number(GST_Val / 2).toFixed(2);


    }


  }



  selectPOItem(event: any, index: any) {
    debugger;

    let po_no = event.target.value;

    this.selectedPO_no = po_no;

    this.ItemCodesList = this._baseService.allProducts.filter(obj => obj.po_no == po_no);

    this.ProductItems[index].item_code = "";

  }


  setProductItems(event: any, index: any) {
    debugger;

    let item_code = event.target.value;


    let element = this.ProductItems[index];
    let findProductItem = this._baseService.allProducts.find(obj => (obj.po_no == this.selectedPO_no && obj.item_code == item_code));


    element.item_desc = findProductItem.item_desc;
    element.hsn_code = findProductItem.hsn_code;
    element.qty = Number(findProductItem.qty);
    element.unit_price = Number(findProductItem.price).toFixed(2);
    element.total = Number(element.qty) * Number(element.unit_price);

    element.total = element.total.toFixed(2);


    // this.ProductItems.forEach(element => {

    //   let findProductItem = this._baseService.allProducts.find(obj => (obj.po_no == this.selectedPO_no && obj.item_code == item_code));

    //   element.item_code = findProductItem.item_code;
    //   element.item_desc = findProductItem.item_desc;
    //   element.hsn_code = findProductItem.hsn_code;
    //   element.qty = Number(findProductItem.qty);
    //   element.unit_price = Number(findProductItem.price).toFixed(2);
    //   element.total = Number(element.qty) * Number(element.unit_price);

    //   element.total = element.total.toFixed(2);


    // });
  }



  makeInvoice() {

    if (this.from_Address && this.to_Address) {

      if (this.ProductItems.length > 0) {

        let isProductEmpty = false;

        this.ProductItems.forEach(element => {

          if (this.invoice_type == 'Invoice') {
            if (!element.po_no || !element.item_code || !element.item_desc || !element.hsn_code || !element.qty) {
              isProductEmpty = true;
            }

          }

        });



        if (isProductEmpty) {
          this._baseService.showError("Select Product Information!");
        }
        else {
          let fromAddress = this._baseService.allCustomerAddresses.find(obj => obj.id == this.from_Address);
          let toAddress = this._baseService.allCustomerAddresses.find(obj => obj.id == this.to_Address);

          this._baseService.InvoiceData = {
            invoice_type: this.invoice_type,
            invoice_no: this._baseService.InvoiceData.invoice_no,
            invoiceDate: this.invoiceDate,
            from_Address: fromAddress,
            to_Address: toAddress,
            ProductItems: this.ProductItems,
            totalObject: this.totalObject,
            is_change_order: true
          };

          this._baseService.redirectTo('invoice-preview');
        }


      }


    }
    else {

      if (!this.from_Address) {
        this._baseService.showError("Select  Billing Address!");
      }
      else {
        this._baseService.showError("Select Delivery Address!");
      }


    }

  }

}
